export default "__VITE_ASSET__88f0316a__"